import '../css/components/loader.css';

const Loader = () => {
  return (
    <div className="container-loader">
      <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>)
}

export default Loader;